var scope_0 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0fde2d184d895caae71212859a6d1ae0.js').default;
var scope_1 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2d5c2a1c93fabeb23425aeccc16fc070.js').default;
var scope_2 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8296d5f2b61bb081443ba3ecd208ed5d.js').default;
var scope_3 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84009b5c8e0c6b88378b19af524c2017.js').default;
var scope_4 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c26bc5916bd769dc177a8db85c1a2188.js').default;
var scope_5 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c43050fb17bcc6b1a3a5e030530ec22c.js').default;
var scope_6 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d0924937f5ec6e7a62da34d1580ef703.js').default;
var scope_7 = require('/Users/vintharas/GitHub/barbarianmeetscoding/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    